// extracted by mini-css-extract-plugin
export default {"container":"Container-module__container--befa"};